import { useState } from "react";

const ACCEPT = ["匿名文字", "聊天截图", "现场视频", "录音音频", "合同票据", "时间线线索"];

export default function ReportCta() {
  const [tip, setTip] = useState("");
  const [done, setDone] = useState(false);

  return (
    <section id="report" className="bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-6 md:px-6">
        <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-primary-700 via-primary-800 to-primary-900 text-background-50">
          {/* decorative */}
          <div className="pointer-events-none absolute -right-10 -top-10 h-52 w-52 rounded-full bg-accent-400/20 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-16 -left-8 h-56 w-56 rounded-full bg-accent-500/15 blur-2xl" />

          <div className="relative grid grid-cols-1 gap-0 lg:grid-cols-2">
            {/* report column */}
            <div className="p-6 md:p-9">
              <span className="flex items-center gap-2 text-[13px] font-bold uppercase tracking-widest text-accent-300">
                <i className="ri-eye-off-line w-4 h-4 flex items-center justify-center" />
                匿名投稿 · 全程加密
              </span>
              <h3 className="mt-3 font-heading text-[24px] font-black leading-snug md:text-[30px]">
                你手上是不是也有张瓜牌？
              </h3>
              <p className="mt-2 max-w-md text-[14px] leading-6 text-background-50/85">
                匿名、不留痕、可加价回收的独家线索我们都接。提交后编缉组会先交叉核验，能证实的才会进入素材池。
              </p>

              <div className="mt-4 flex flex-wrap gap-1.5">
                {ACCEPT.map((a) => (
                  <span
                    key={a}
                    className="rounded-full bg-background-50/10 px-2.5 py-1 text-[12px] text-background-50/90"
                  >
                    {a}
                  </span>
                ))}
              </div>

              <div className="mt-4 rounded-lg bg-background-50/10 p-2 ring-1 ring-background-50/15">
                <textarea
                  value={tip}
                  onChange={(e) => setTip(e.target.value)}
                  maxLength={500}
                  rows={3}
                  placeholder="描述你掌握到的线索，或选择素材类型后点下方提交（本站仅静态展示，不真正接收）……"
                  className="w-full resize-none bg-transparent text-[14px] leading-6 text-background-50 placeholder:text-background-50/40 focus:outline-none"
                />
                <div className="flex items-center justify-between border-t border-background-50/15 pt-2">
                  <span className="text-[11px] text-background-50/50">{tip.length}/500</span>
                  <button
                    type="button"
                    onClick={() => {
                      if (tip.trim()) {
                        setDone(true);
                        setTip("");
                        window.setTimeout(() => setDone(false), 2200);
                      }
                    }}
                    className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-[14px] font-bold text-primary-800 transition-colors hover:bg-accent-300"
                  >
                    <i className="ri-lock-2-line w-4 h-4 flex items-center justify-center" />
                    加密提交
                  </button>
                </div>
                {done && (
                  <p className="mt-1.5 flex items-center gap-1.5 text-[12px] text-accent-300">
                    <i className="ri-checkbox-circle-line w-4 h-4 flex items-center justify-center" />
                    收到，编缉组会尽快看（演示提示，未真实上传）。
                  </p>
                )}
              </div>
            </div>

            {/* download column - prominent per fingerprint */}
            <div className="flex flex-col justify-center border-t border-background-50/15 bg-background-50/5 p-6 md:p-9 lg:border-l lg:border-t-0">
              <span className="flex items-center gap-2 text-[13px] font-bold uppercase tracking-widest text-accent-300">
                <i className="ri-download-2-line w-4 h-4 flex items-center justify-center" />
                蹲瓜不迷路
              </span>
              <h3 className="mt-3 font-heading text-[24px] font-black leading-snug md:text-[30px]">
                下载海角天崖 App，瓜先到一步
              </h3>
              <p className="mt-2 max-w-md text-[14px] leading-6 text-background-50/85">
                推送只发大瓜、绝不刷屏。支持一键匿名订阅某个人物的全部相关爆料，官方也不看你在追谁。
              </p>

              <div className="mt-5 flex flex-wrap items-center gap-3">
                <a
                  href="#report"
                  className="flex items-center gap-2.5 whitespace-nowrap rounded-lg bg-background-50 px-5 py-3 text-[15px] font-bold text-primary-900 transition-colors hover:bg-accent-300"
                >
                  <i className="ri-apple-fill w-6 h-6 flex items-center justify-center" />
                  App Store
                </a>
                <a
                  href="#report"
                  className="flex items-center gap-2.5 whitespace-nowrap rounded-lg bg-foreground-950 px-5 py-3 text-[15px] font-bold text-background-50 ring-1 ring-background-50/25 transition-colors hover:bg-foreground-800"
                >
                  <i className="ri-android-fill w-6 h-6 flex items-center justify-center" />
                  Android 下载
                </a>
              </div>

              <div className="mt-5 flex items-center gap-4">
                <span className="grid h-[86px] w-[86px] place-items-center rounded-md bg-background-50 p-1.5 text-primary-900">
                  <i className="ri-qr-scan-line w-full h-full flex items-center justify-center" />
                </span>
                <div className="text-[13px] leading-6 text-background-50/80">
                  <p className="flex items-center gap-1.5">
                    <i className="ri-check-line w-4 h-4 flex items-center justify-center text-accent-300" />
                    扫一扫即装
                  </p>
                  <p className="flex items-center gap-1.5">
                    <i className="ri-check-line w-4 h-4 flex items-center justify-center text-accent-300" />
                    首月推送免打扰
                  </p>
                  <p className="flex items-center gap-1.5">
                    <i className="ri-check-line w-4 h-4 flex items-center justify-center text-accent-300" />
                    iOS 12+ / Android 8+
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}